export enum STORAGE {
  FORM_DATA = "formData",
  POAP_FORM_DATA = "poapFormData",
  LOST_ITEM_FORM_DATA = "lostItemFormData",
  TAPPED_ITEM_FORM_DATA = "tappedItemFormData",
  COLLECT_ADDRESSES = "collectAddresses",
  EMAIL = "email",
  AIRDROP = "airdrop",
}
